<template>
  <div id="page-wrap">
    <a id="advoco" href="http://www.advoco.lt/" target="_blank"
      ><img alt="" title="" src="/assets/advoco.png"
    /></a>
    <div id="header">
      <div class="menu">
        <ul>
          <li class="page_item page-item-2 current_page_item">
            <router-link to="/" title="Apie save">Apie save</router-link>
          </li>
          <li class="page_item page-item-22">
            <router-link to="/straipsniai" title="Straipsniai">Straipsniai</router-link>
          </li>
          <li class="page_item page-item-152">
            <router-link to="/krikscioniu-partija" title="Krikščionių partija"
              >Krikščionių partija</router-link
            >
          </li>
          <li class="page_item page-item-4">
            <router-link to="/kontaktai" title="Kontaktai">Kontaktai</router-link>
          </li>
        </ul>
      </div>

      <h1><span>Advokatas</span><router-link to="/">Romaldas Petras Damušis</router-link></h1>
      <div class="description">asmeninis puslapis</div>
    </div>

    <div id="sidebar">
      <h2>Kaltinti gali bet kas - aš galiu apginti!</h2>
      <div id="face"><img src="/assets/face.png" title="" /></div>
      <div id="intro">
        <strong>Romaldas Petras Damušis</strong><br />
        Darbo praktika nuo 1973 m. <br />
        Teisininkas nuo 1978 m. <br />
        Advokatas nuo 1999 m. <br />
        Krikščionių partijos <br />
        Šakių skyriaus pirmininkas.<br />
        Credo: Laikas ir proga neįstengs padėti tam, kuris pats nesistengia.<br />Tel.Nr.
        <strong>8-345-60282, 8-686-79-155</strong>
      </div>
      <!-- <form action="/" id="searchform" method="get">
        <div>
          <h2>Ieškoti</h2>
          <input type="text" id="s" name="s" value="" />
          <input type="submit" value="Ieškoti" id="searchsubmit" />
        </div>
      </form>
      <br /><br />
      <h2>Archyvas</h2>
      <ul>
        <li><a href="/2012/01/" title="Sausio 2012">Sausio 2012</a></li>
        <li><a href="/2011/02/" title="Vasario 2011">Vasario 2011</a></li>
        <li><a href="/2011/01/" title="Sausio 2011">Sausio 2011</a></li>
        <li><a href="/2010/12/" title="Gruodžio 2010">Gruodžio 2010</a></li>
      </ul>
      <br /><br />
      <h2>Kategorijos</h2>
      <ul>
        <li class="cat-item cat-item-1">
          <a
            href="/category/uncategorized/"
            title="Peržiūrėti visus temos Kita įrašus"
            >Kita</a
          >
          (4)
        </li>
        <li class="cat-item cat-item-6">
          <a
            href="/category/krikscioniu-partija/"
            title="Peržiūrėti visus temos Krikščionių partija įrašus"
            >Krikščionių partija</a
          >
          (3)
        </li>
        <li class="cat-item cat-item-5">
          <a
            href="/category/teisine-konsultacija/"
            title="Peržiūrėti visus temos Teisinė konsultacija įrašus"
            >Teisinė konsultacija</a
          >
          (4)
        </li>
      </ul>
      <br /><br /> -->
      <li id="linkcat-2" class="linkcat">
        <h2>1. Svarbios nuorodos</h2>
        <ul class="xoxo blogroll">
          <li><a href="http://www.advoco.lt/">Lietuvos advokatūra</a></li>
          <li>
            <a href="http://www.antstoliai.lt/">Lietuvos antstolių rūmai</a>
          </li>
          <li><a href="http://www.notarai.lt/">Lietuvos notarų rūmai</a></li>
          <li>
            <a href="http://www.lrs.lt/"
              >Lietuvos Respublikos Seimo naujienos</a
            >
          </li>
          <li>
            <a href="http://www.lrv.lt/"
              >Lietuvos Respublikos Vyriausybės naujienos</a
            >
          </li>
          <li><a href="http://www.mzinios.lt/">Mokesčių žinios</a></li>
          <li>
            <a href="http://www.teismai.lt/administracija"
              >Nacionalinė teismų administracija</a
            >
          </li>
          <li>
            <a href="http://www3.lrs.lt/pls/inter/veliausios_zinios"
              >Naujausios „Valstybės žinios“</a
            >
          </li>
          <li><a href="http://www.kada.lt/">Registrų centras</a></li>
          <li><a href="http://www.infolex.lt/">Teisės portalas Infolex</a></li>
          <li>
            <a href="http://www.nplc.lt/links/liet/teis-inst.htm"
              >Teisėsaugos institucijos</a
            >
          </li>
          <li><a href="http://www.tm.lt/">Teisingumo Ministerija</a></li>
          <li><a href="http://www.lat.litlex.lt/">Teismų praktika</a></li>
          <li><a href="http://www.vrm.lt/">Vidaus reikalų ministerija</a></li>
        </ul>
      </li>
      <li id="linkcat-4" class="linkcat">
        <h2>2. Naudingos nuorodos</h2>
        <ul class="xoxo blogroll">
          <li><a href="http://www.sakiai.lt/">Apie Šakius</a></li>
          <li><a href="http://www.drg.lt/">Laikraštis „Draugas“</a></li>
          <li><a href="http://www.smirnovas.lt/">Patikimas bičiulis</a></li>
          <li><a href="http://www.sakieciai.lt/">Šakių NVO svetainė</a></li>
          <li>
            <a href="http://www.sakiai.rvb.lt/">Šakių viešoji biblioteka</a>
          </li>
        </ul>
      </li>
    </div>
    <router-view />
    <div id="break">&nbsp;</div>
    <div id="footer">
      © 2020 Romaldas Petras Damušis
    </div>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>
